export default __webpack_public_path__ + "static/media/dynamexMotor@2x.590b2de7.png";